import Vue from "vue";
import * as Sentry from "@sentry/vue";

Sentry.init({
  Vue,
  dsn: "https://97cd70d1159345c190f28bb561863f65@o588961.ingest.sentry.io/5940276",
  release: "1.0.5",
  environment: process.env.VUE_APP_ENV
});
